<template>
  <div class="terms-form">
    <v-form
      ref="form"
      v-if="form"
      style="max-width: 700px"
      @submit.prevent="onSubmit"
    >
      <v-row>
        <v-col cols="12" sm="6">
          <label class="text-field-label">Last Update</label>
          <v-text-field
            flat
            solo
            readonly
            hide-details="auto"
            class="mt-2"
            placeholder="Last Update"
            v-model="lastUpdate"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12">
          <label class="text-field-label">Content</label>
          <editor v-model="form.content"></editor>
        </v-col>
      </v-row>

      <div class="mt-4">
        <v-btn
          type="submit"
          color="primary"
          depressed
          class="mr-4 px-6"
          height="40px"
          :loading="form.$busy"
          >Update</v-btn
        >
      </div>
    </v-form>

    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <v-btn text @click="snackbar.show = false">OK</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import Terms from '@/models/Terms'
import { mdiCheck, mdiAlertCircleOutline } from '@mdi/js'
import { mapActions } from 'vuex'
import Editor from '@/components/wysiwyg/Editor'
import Form from '@/utils/form'

export default {
  props: {
    terms: {
      type: [Terms, Object]
    }
  },

  components: {
    Editor
  },

  data() {
    return {
      icons: {
        check: mdiCheck,
        alert: mdiAlertCircleOutline
      },
      form: new Form({
        content: null
      }),
      snackbar: {
        show: false,
        message: null,
        color: ''
      }
    }
  },

  computed: {
    lastUpdate() {
      return this.terms ? this.terms.lastUpdate : null
    }
  },

  watch: {
    terms(value) {
      this.initForm()
    }
  },

  methods: {
    ...mapActions({
      updateTerms: 'support/updateTerms'
    }),

    initForm() {
      if (this.terms) {
        this.form = new Form(this.terms)
      }
    },

    async onSubmit() {
      if (this.form.$busy) return
      this.form.$setLoading(true)

      await this.updateTerms(this.form.$data())
        .then(data => {
          this.form.$setLoading(false)
          this.showSnackbar('Terms Of Use successfully updated!', 'success')
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
          this.showSnackbar(this.form.$errorMessage, 'danger')
        })
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  },

  mounted() {
    this.initForm()
  }
}
</script>
